import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, dashboardPathForRole } from "../context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();

  if (user === undefined) {
    return (
      <div
        data-testid="protected-route-loading"
        className="min-h-screen flex items-center justify-center bg-brand-bg"
      >
        <div className="text-brand-muted">Caricamento…</div>
      </div>
    );
  }

  if (user === null) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    return <Navigate to={dashboardPathForRole(user.role)} replace />;
  }

  return children;
}
